<template>
  <div>
    <page-header title="ویرایش مدیر"></page-header>

    <crud-generator v-if="admin" :fields="fields" @submit="submit" :current-values="admin" name="admins"></crud-generator>
  </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader";
import CrudGenerator from "@/components/General/CrudGenerator";

export default {
  name: "UpdateAdmin",

  components: {CrudGenerator, PageHeader},

  data() {
    return {
      fields: [],
      admin: null,
    }
  },

  mounted() {
    this.getAdmin()
  },

  methods: {
    getAdmin() {
      this.$store.dispatch("singleAdmin", this.$route.params.id)
      .then((res) => {
        this.admin = res.data
        this.fillFields()
      })
    },

    fillFields() {
      this.fields = [
        {
          name: 'name',
          label: 'نام',
          cols: 4,
          type: 'text',
          direction: 'rtl',
        },
        {
          name: 'email',
          label: 'ایمیل',
          cols: 4,
          type: 'text',
          direction: 'ltr',
        },
        {
          name: 'password',
          label: 'رمز عبور',
          cols: 4,
          type: 'text',
          direction: 'ltr'
        },
      ]
    },

    submit(values) {
      this.$store.dispatch("updateAdmin", {data: values, identifier: this.$route.params.id})
          .then(() => {
            this.$router.push('/admins')
          })
    }
  }
}
</script>

<style scoped>

</style>